<template>
  <div   :class="allEyesModel?'flightDetailRealTimeContainer_eyeshield':'flightDetailRealTimeContainer'"  id="flightDetailRealTimeContainer" >
    <div class="titleContainer">
      <div class="row">
        <div class="name">飞机型号:<span class="content">{{ clickPlaneInfo.uasModel||'— —' }}</span></div
        >
      </div>
      <div class="row">
        <div class="name">飞机编号:<span style="cursor: pointer" class="content" :title="clickPlaneInfo.uasID">{{ clickPlaneInfo.uasID&&clickPlaneInfo.uasID.substring(0,6)+"..."||'— —'}}</span></div>

      </div>
    </div>
    <div class="chartMainContainer">

      <div class="headerInfoContainer">

        <div class="leftInfoContainer">
          <div class="realTitle">飞行速度m/s</div>
          <div class="content">{{clickPlaneInfo.gs!=undefined?clickPlaneInfo.gs:'— —'}}</div>
          <!--          <div class="content">{{29}}</div>-->
        </div>

        <div class="centerInfoContainer">
          <div class="column">
            <div class="realTitle">滚转</div>
            <div class="content">{{ clickPlaneInfo.roll!=undefined?clickPlaneInfo.roll:'— —'}}°</div>
          </div>
          <div class="column">
            <div class="realTitle">偏航</div>
            <div class="content">{{clickPlaneInfo.course!=undefined?clickPlaneInfo.course:'— —'}}°</div>
          </div>
          <div class="column">
            <div class="realTitle">俯仰</div>
            <div class="content">{{clickPlaneInfo.pi!=undefined?clickPlaneInfo.pi:'— —'}}°</div>
          </div>
        </div>

        <div class="rightInfoContainer">
          <div class="realTitle">相对高度m</div>
          <div class="content">{{clickPlaneInfo.height!=undefined?clickPlaneInfo.height:'— —'}}</div>
        </div>

      </div>
      <div class="centerChartContainer">
        <img :src="leftScale" class="leftScale" />
        <div class="centerDashboardContainer">
          <canvas id="dashboardChart" class="dashboardChart" width="140" height="262" />
          <img
            id="dashboardScale"
            src="../../../assets/img/home/flightDetail/dashboardScale.png"
            style="display: none"
          />
          <img
            id="headingScale"
            src="../../../assets/img/home/flightDetail/headingScale.png"
            style="display: none"
          /><img
          id="headingFlight"
          :src="require(`../../../assets/img/home/${allEyesModel?'flightDetail_eyes':'flightDetail'}/headingFlight.png`)"
          style="display: none"
        /><img
          id="pitch"
          :src="require(`../../../assets/img/home/${allEyesModel?'flightDetail_eyes':'flightDetail'}/pitch.png`)"
          style="display: none"
        />
          <!--          <img-->
          <!--          id="pointer"-->
          <!--          src="../../../assets/img/home/flightDetail/pointer.png"-->
          <!--          style="display: none"-->
          <!--        />-->
          <img
            id="rudder"
            :src="require(`../../../assets/img/home/${allEyesModel?'flightDetail_eyes':'flightDetail'}/rudder.png`)"
            style="display: none"
          />
          <label>偏航:&nbsp;{{clickPlaneInfo.yaw?clickPlaneInfo.yaw:'— —'}}</label>
        </div>
        <img :src="rightScale" class="rightScale" />

        <div class="leftAxisContainer axisContainer">
          <div class="axis">{{ leftAxis[7] }}</div>
          <div class="axis">{{ leftAxis[6] }}</div>
          <div class="axis">{{ leftAxis[5] }}</div>
          <div class="axis">{{ leftAxis[4] }}</div>
          <div class="axis">{{ leftAxis[3] }}</div>
          <div class="axis">{{ leftAxis[2] }}</div>
          <div class="axis">{{ leftAxis[1] }}</div>
          <div class="axis">{{ leftAxis[0] }}</div>
        </div>

        <div class="leftTargetAxis">T {{ leftAxis[4] }}</div>
        <div id="leftRealAxis" class="leftRealAxis">R {{ speed }}</div>

        <div class="rightAxisContainer axisContainer">
          <div class="axis">{{ rightAxis[7] }}</div>
          <div class="axis">{{ rightAxis[6] }}</div>
          <div class="axis">{{ rightAxis[5] }}</div>
          <div class="axis">{{ rightAxis[4] }}</div>
          <div class="axis">{{ rightAxis[3] }}</div>
          <div class="axis">{{ rightAxis[2] }}</div>
          <div class="axis">{{ rightAxis[1] }}</div>
          <div class="axis">{{ rightAxis[0] }}</div>
        </div>
        <div class="rightTargetAxis">{{ rightAxis[4] }} T</div>
        <div id="rightRealAxis" class="rightRealAxis">{{ height }} R</div>
      </div>
      <div class="footerInfoContainer">
        <div class="leftInfoContainer">
          <div class="realTitle">相对地面速度</div>
          <div class="content">{{clickPlaneInfo.gs!=undefined?clickPlaneInfo.gs:'— —'}}</div>
        </div>
        <div class="centerInfoContainer">
          <div class="realTitle">空速</div>
          <div class="content">{{clickPlaneInfo.gs!=undefined?clickPlaneInfo.gs:'— —'}}</div>
        </div>
        <div class="rightInfoContainer">
          <div class="realTitle">海拔高度</div>
          <div class="content">{{clickPlaneInfo.altitude!=undefined?clickPlaneInfo.altitude:'— —'}}</div>
        </div>
      </div>
    </div>
    <div    id="bottomChart" style="overflow: hidden">

    </div>
  </div>
</template>

<script type="text/javascript">
import cloudy from "../../../assets/img/home/flightDetail/cloudy.png";
import unlockImg from "../../../assets/img/home/flightDetail/unlockImg.png";
import takeOffImg from "../../../assets/img/home/flightDetail/takeOffImg.png";
import alternateLandImg from "../../../assets/img/home/flightDetail/alternateLandImg.png";
import returnImg from "../../../assets/img/home/flightDetail/returnImg.png";
import landImg from "../../../assets/img/home/flightDetail/landImg.png";
import hoverImg from "../../../assets/img/home/flightDetail/hoverImg.png";
import cruiseImg from "../../../assets/img/home/flightDetail/cruiseImg.png";
import airdropImg from "../../../assets/img/home/flightDetail/airdropImg.png";
import leftScale from "../../../assets/img/home/flightDetail/leftScale.png";
import rightScale from "../../../assets/img/home/flightDetail/rightScale.png";
import speedImg1 from "../../../assets/img/home/flightDetail/speedImg1.png";
import echarts from "echarts";
export default {
  name: "flightDetailRealTime",
  data() {
    return {
      initFlag: false,
      dashboardScaleFlag: false,
      headingScaleFlag: false,
      headingFlightFlag: false,
      pitchFlag: false,
      // pointerFlag: false,
      rudderFlag: false,
      selectSpeedBgShow: false, //是否显示速度选择背景
      heading: 180,
      roll: 0,
      pitch: 0,
      type1: "reduce",
      type2: "reduce",
      type3: "reduce",
      leftAxis: [0, 5, 10, 15, 20, 25, 30, 35],
      rightAxis: [0, 200, 400, 600, 800, 1000, 1200, 1400],
      weatherIcon: cloudy,
      unlockImg: unlockImg,
      takeOffImg: takeOffImg,
      alternateLandImg: alternateLandImg,
      returnImg: returnImg,
      landImg: landImg,
      hoverImg: hoverImg,
      cruiseImg: cruiseImg,
      airdropImg: airdropImg,
      leftScale: leftScale,
      rightScale: rightScale,
      speedImg: speedImg1,
      speed: 0,
      height: 800,
      axisHeight: 255,
      axisInitHeight: 41,
      axisMinHeight: 1400,
      axisMinSpeed: 35,
      leftAxisStep: 1,
      rightAxisStep: 40,
      playOrPauseName: "播放",
      currentPoint:[],
      myChart:null,

    };
  },
  props:{
     allEyesModel:{
      type: Boolean,
      default: false
    },
    planeChartData:{
      type: Array,
      default: []
    },
    isHistory:{
      type: Boolean,
      default: false
    },
    clickPlaneInfo:{
      type: Object,
      default: {}
    },
  },
  // props: ["clickPlaneInfo", "planeChartData","planeDetailData","isHistory", "playOrPause", "replaySpeed", "taskPlan","allEyesModel"],
  // props: ["clickPlaneInfo", "planeChartData","planeDetailData","isHistory", "playOrPause", "replaySpeed", "taskPlan", "currentPoint"],
  methods: {
    //添加图片的事件监听
    initListeners() {
      const arrs = [
        "dashboardScale",
        "headingScale",
        "headingFlight",
        "pitch",
        // "pointer",
        "rudder",
      ];
      for (let index = 0; index < arrs.length; index++) {
        const element = arrs[index];
        const obj = document.getElementById(element);
        const vue = this;
        obj.onload = (e) => {
          const id = e.currentTarget.getAttribute("id");
          vue.$data[id + "Flag"] = true;
          vue.doDrawChart();
        };
      }
    }, //初始时绘制仪表盘
    initChart() {
      this.doDrawChart();
      this.drawLineChart()
    },
    doDrawChart() {
      const chart = document.getElementById("dashboardChart");
      if (chart) {
        const context = chart.getContext("2d");
        context.clearRect(0, 0, chart.width, chart.height);
        this.drawDashboard(context);
        this.drawHeading(context);
      }
    },

    drawLineChart() {
      this.myChart = echarts.init(document.getElementById('bottomChart'));
      let option = {
        tooltip: {
          trigger: 'axis', // 鼠标悬停时触发
          formatter: function (params) {
            let result = `时间：<strong>${params[0].name}</strong><br/>`; // 显示时间
            result += `速度: ${params[0].value}m/s<br/>高度: ${params[1].value}m<br/>`; // 显示数据
            return result;
          },
          backgroundColor: '#fff',
          borderColor: '#ccc',
          borderWidth: 1,
          padding: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
      legend: {
          icon: 'line', // 关键：使用线条图标
          itemStyle: {
            color: 'auto' // 自动使用系列的颜色
          },
          data: ['速度(m/s)', '高度(m)'],
          textStyle: { color: '#ececec' }
        },
        grid: {
          top: 30,
          left: 45,
          right: 32,
          bottom: 30,
          width: 'auto',
          height: 'auto',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          // data: ['9:34','9:35','9:37','9:38','9:39','9:40','9:41'],
          data: this.planeChartData ? this.planeChartData.map(v => {
            return v.time
          }) : [],
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            }
          },
          axisLabel: {
            color: '#fff', // 坐标字体颜色
          },
          axisTick: {
            show: false, // 去掉轴刻度线
          },
          splitLine: { show: false } // 隐藏 x 轴网格线（竖线）
        },
        yAxis: [
          {
            type: 'value',
            name: '速度(m/s)',
            position: 'left',
            boundaryGap: false,
            nameTextStyle: {
              color: '#fff',
            },
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
            },
            axisLabel: {
              color: '#fff', // 坐标字体颜色
            },
            axisTick: {
              show: false, // 去掉轴刻度线
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
              }
            },
            splitLine: { show: false } // 隐藏 y 轴网格线（横线）
          },
          {
            type: 'value',
            name: '高度(m)',
            min: 0,
            position: 'right',
            nameTextStyle: {
              color: '#fff',
            },
            lineStyle: {
              color: 'red', // 坐标轴颜色
            },
            axisLabel: {
              color: '#fff', // 坐标字体颜色
            },
            axisTick: {
              show: false, // 去掉轴刻度线
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)', // 坐标轴颜色
              }
            },
            splitLine: { show: false } // 隐藏 y 轴网格线（横线）
          }
        ],
        series: [
          {
            name: '速度(m/s)',
            type: 'line',
            // smooth: 1,
            smooth: false,
            yAxisIndex: 0,
            // data: [0,10,12,15,30,22,25],
            data: this.planeChartData ? this.planeChartData.map(v => {
              return v.gs
            }) : [],
            lineStyle: {
              color: '#00aeff',
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear', // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {offset: 0, color: 'rgba(0,174,255,1.00)'}, // 0% 处的颜色
                    {offset: 1, color: 'rgba(0,174,255,0.00)'}  // 100% 处的颜色
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            symbol: 'circle',
            symbolSize: 0,
            itemStyle: {
              color: '#00aeff',
              borderWidth: 0
            },
          },
          {
            name: '高度(m)',
            type: 'line',
            // smooth: 1,
            smooth: false,
            yAxisIndex: 1,
            data: this.planeChartData ? this.planeChartData.map(v => {
              return v.altitude
            }) : [],
            // data: [0,20,23,50,60,55,54],
            lineStyle: {
              color: this.allEyesModel?'#ffffff':'#ee3f3f',
              width: 3
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear', // 线性渐变
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {offset: 0, color: this.allEyesModel?'#ffffff':'rgba(238,63,63,1.00)'},
                    {offset: 1, color:this.allEyesModel?'rgba(255,255,255,0.00)':'rgba(238,63,63,0.00)'}
                  ],
                  global: false // 使用区域渐变
                }
              }
            },
            symbol: 'circle',
            symbolSize: 0,
            itemStyle: {
              color: this.allEyesModel?'#ffffff':'#ee3f3f',
              borderWidth: 0
            },
          },
        ]
      };
      this.myChart.setOption(option);
    },
    drawDashboard(context) {
      if (this.$data.dashboardScaleFlag) {
        const dashboardScale = document.getElementById("dashboardScale");
        context.drawImage(dashboardScale, 0, 30, 130, 130);
        this.drawPitch(context);
        // this.drawPointer(context);
        this.drawRudder(context);
      }
    },
    drawPitch(context) {
      if (this.$data.pitchFlag) {
        const pitch = document.getElementById("pitch");
        context.stroke();
        context.strokeStyle = "#00000000";
        context.save();
        context.beginPath();
        context.translate(65, 96);
        let rotate = this.clickPlaneInfo.roll!=undefined?(this.clickPlaneInfo.roll * Math.PI) / 180:0;
        context.rotate(rotate);
        context.arc(0, 0, 50, 0, Math.PI * 2, false);
        context.clip();
        const moveHeight = this.clickPlaneInfo.pi!=undefined?(this.clickPlaneInfo.pi / 10) * 26:0;
        context.drawImage(pitch, -pitch.width / 2, -pitch.height / 2 + moveHeight);
        context.restore();
      }
    },
    drawPointer(context) {
      if (this.$data.pointerFlag) {
        const pointer = document.getElementById("pointer");
        context.stroke();
        context.save();
        context.translate(63 + pointer.width / 2,45 + pointer.height / 2);
        let rotate = this.clickPlaneInfo.roll!=undefined?(this.clickPlaneInfo.roll * Math.PI) / 180:0;
        context.rotate(rotate);
        context.drawImage(pointer, -pointer.width / 2, -pointer.height / 2);
        context.restore();
      }
    },
    drawRudder(context) {
      if (this.$data.rudderFlag) {
        const rudder = document.getElementById("rudder");
        context.drawImage(rudder, 48, 96);
      }
    },
    drawHeading(context) {
      if (this.$data.headingScaleFlag) {
        const headingScale = document.getElementById("headingScale");
        context.drawImage(headingScale, 20, 160);
        this.drawChartFlight(context);
      }
    },
    drawChartFlight(context) {
      if (this.$data.headingFlightFlag) {
        const headingFlight = document.getElementById("headingFlight");
        context.stroke();
        context.save();
        context.translate(
          20 + headingScale.width / 2,
          160 + (headingScale.height - 5) / 2
        );
        let heading = this.clickPlaneInfo.course!=undefined?(this.clickPlaneInfo.course * Math.PI) / 180:0;
        context.rotate(heading);
        context.drawImage(
          headingFlight,
          -headingFlight.width / 2,
          -headingFlight.height / 2
        );
        context.restore();
      }
    },
    resetSpeedArray(speed) {
      const speedArr = [];
      if (this.$data.axisMinSpeed < speed) {
        const axis = Math.floor(speed / 7) + this.$data.leftAxisStep;
        for (let index = 0; index < 8; index++) {
          speedArr[index] = index * axis;
        }
        this.$data.leftAxis = speedArr;
      }
      this.$data.speed = speed;
      const max = this.$data.leftAxis[7];
      document.getElementById("leftRealAxis").style.top =
        this.$data.axisInitHeight + ((max - speed) * this.$data.axisHeight) / max - 3 + "px";
    },
    resetHeightArray(height) {
      const heightArr = [];
      if (this.$data.axisMinHeight < height) {
        const axis = Math.floor(height / 7) + this.$data.rightAxisStep;
        for (let index = 0; index < 8; index++) {
          heightArr[index] = index * axis;
        }
        this.$data.rightAxis = heightArr;
      }
      this.$data.height = height;
      const max = this.$data.rightAxis[7];
      document.getElementById("rightRealAxis").style.top =
        this.$data.axisInitHeight + ((max - height) * this.$data.axisHeight) / max - 3 + "px";
    },
    endFly() {
      this.$emit("endFly");
    },
    pauseOrPlay() {
      this.$emit("pauseOrPlay");
    },
    setSpeed(speed) {
      this.$emit("changeSpeed", speed);
    },
    handleResize() {
      this.myChart.resize();
    }
  },
  mounted() {
    if (!this.$data.initFlag) {
      this.$data.initFlag = true;
      this.initListeners();
      this.initChart();
      window.addEventListener('resize', this.handleResize, {passive: true});
      this.resetSpeedArray(0);
      this.resetHeightArray(0);
    }
  },
  watch: {
    planeChartData(nval, oval) {
      if (nval) {
        this.drawLineChart()
      }
    },
    allEyesModel(nval, oval) {
        this.drawLineChart()
    },
    playOrPause(nval, oval) {
      if (nval) {
        this.$data.playOrPauseName = "暂停";
      } else {
        this.$data.playOrPauseName = "播放";
      }
    },
    clickPlaneInfo(nval, oval) {
      if (nval) {
        this.initChart();
        this.resetSpeedArray(nval.gs);
        this.resetHeightArray(nval.height);
      }
    },
  },
  computed: {},
  components: {},
  beforeDestroy() {
    clearInterval(this.temp)
  },
};
</script>

<style scoped >
@import "../../../assets/css/home/smallModel/flightera.scss";

</style>



// WEBPACK FOOTER //
// src/components/home/smallModel/flightera.vue